module.exports = __webpack_public_path__ + "media/images/icon-order-menu-16eee86d9929b1e52340b209d8e098ec.svg";